export const CONFIRM_DELETE_PROJECT = "DELETE THIS PROJECT";
